import React, { useCallback, useMemo } from "react";
import cls from "./style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";
import RightToLeft from "../../../../../../components/transitions/right-to-left";
import { Formik, Form, FieldArray, Field, useField } from "formik";
import ReactDOM from 'react-dom';
import { FormattedMessage, useIntl } from "react-intl";
import { v4 } from "uuid";
import { useSelector } from "react-redux";
import { BigButton } from "../../../../../../../client/components/button";
import { Iconfont } from "../../../../../../components/icon/iconfont";
import { useQuery } from "../../../../../../hooks/common";
import { fetchSendShareEmails } from "../../../../../../../api";
import Alert from "../../../../../../components/alert";

const InputFiled = props =>{
    useStyles(cls);
    const { InputProps, title, eludeValidate = false } = props;
    const Intl = useIntl();

    const validate = useCallback(value => {
        if(eludeValidate) return;
        let errorMessage;
        const emailReg = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
        // if (!value) {
        //   errorMessage = Intl.formatMessage({ id: "enter_email_address", defaultMessage: "Enter you email address" });
        // }else 
        if(!title && (value && !emailReg.test(value))){
            errorMessage = Intl.formatMessage({ id: "account_is_invalid", defaultMessage: "The email you entered is invalid" });
        }
        return errorMessage;
    }, []);

    const [field, meta, helpers] = useField({...InputProps, validate});

    const phoneId = useMemo(() =>{
        return v4();
    },[]);

    return <div className={cls.InputFiled}>
        {
            title && <label htmlFor={phoneId} className={cls.InputLabel}>{title}</label>
        }
        
        <div className={`${cls.InputItem} ${meta.touched && meta.error?cls.ErrorCon:""}`}>
            <input 
                {...field} 
                {...InputProps} 
                autoComplete={"off"}
                id={phoneId}
            />
        </div>
    </div>
}

const ShareEmailForm = props =>{
    useStyles(cls);
    const { exChange, shareUrl, onClose } = props;
    const Intl = useIntl();
    const global = useSelector(state=>state.global);
    const { config } = global;
    const query = useQuery();

    const initValus = useMemo(() =>{
        if(query?.faceurl){
            return {
                subject:Intl.formatMessage({ id: "share_extra_game_play", defaultMessage: "Click on the link and get me an extra game play" }),
                note: Intl.formatMessage({ id: "share_draw_luck_gifts", defaultMessage: "{name} Black Friday Lucky Draw. Play and win iPhone 13, {name} beauty faves, Bonus Points, Coupons & more."}, {name:config?.name})
            }
        }else{
            return {
                subject:Intl.formatMessage({ id: "open_to_points_reward", defaultMessage: "Open to receive mystery points rewards" }),
                note: Intl.formatMessage({ id: "share_textarea_description", defaultMessage: "{name} has so many must-haves! Register now for points rewards to shop at {name}. {value}. Don't miss this chance!"}, {name:config?.name, value:exChange})
            }
        }
    }, [config, query]);

    const handleSubmit = async (values, formikBag) =>{
        let hasEmailValue = values.emails.some(item=>!!item);
        if(!hasEmailValue){
            Alert(Intl.formatMessage({ id: "enter_email_address", defaultMessage: "Enter you email address" }));
            formikBag?.setSubmitting(false);
            return;
        }

        let emails = values.emails.filter(item=>!!item);

        let params = {
            emails: emails.join(","),
            shareURL:shareUrl,
            subject: values.subject,
            content: values.note,
            shareTempateCode:2
        };
        if(query?.faceurl){
            params = {...params, shareTempateCode:1}
            if(window.GeekoSensors){
                window.GeekoSensors.Track('lottery', {
                    redeem_points_type: "分享兑换",
                    is_redeem_points: '否',
                    activity_type: "黑五",
                })
            }
        }
        let response = await fetchSendShareEmails(params);
        formikBag?.setSubmitting(false);
        if(response?.code === 200){
            Alert(Intl.formatMessage({ id: "success", defaultMessage: "Success" }), {
                onClose:() =>{
                   if(query?.faceurl){
                        window.history.back();
                   }else{
                    onClose?.();
                   }
                }
            });
            
            formikBag?.resetForm();
        }else{
            response?.result && Alert(response.result);
        }
        
    }

    return <div className={cls.ShareEmailForm}>
        <Formik
            initialValues={{ 
                emails: ['', ''],
                ...initValus
            }}
            onSubmit={handleSubmit}
            enableReinitialize 
            validate={(errors, values) =>{

            }}
        >
            {({values, isSubmitting}) =>(
                <Form >
                    <p className={cls.ToLine}>To:</p>

                    <FieldArray
                        name="emails"
                        render={arrayHelpers => (
                            <div>
                                {
                                    values?.emails.map((friend, index) => (
                                        <InputFiled 
                                            key={index}
                                            InputProps={{
                                                name:`emails.${index}`,
                                                placeholder:"Your friend's email address"
                                            }}
                                        />
                                    ))
                                }

                                <div className={cls.InviteMore}>
                                    {
                                        values?.emails?.length < 10 ? (
                                            <button type="button" onClick={() => arrayHelpers.push("")}>Invite More +</button>
                                        ) : (
                                            <p className={cls.NoMore}><FormattedMessage id="share_friend_max_10" defaultMessage="The link can be shared with {value} friends at one time" values={{value:10}} /></p>
                                        )
                                    }
                                </div>
                            </div>
                        )}
                    />

                    <InputFiled 
                        title={Intl.formatMessage({ id: "email_title", defaultMessage: "Email Title" })}
                        eludeValidate
                        InputProps={{
                            name:'subject'
                        }}
                    />

                    <Field name="note">
                        {({ field, form, meta }) => (
                            <div className={cls.InputFiled}>
                                <label className={cls.InputLabel}><FormattedMessage id="email_notes" defaultMessage="Email Notes" /></label>
                                
                                <div className={`${cls.TextArea} ${meta.touched && meta.error?cls.ErrorCon:""}`}>
                                    <textarea 
                                        {...field} 
                                    />
                                </div>
                            </div>
                        )}
                    </Field>

                    <div className={cls.SubmitButton}>
                        <BigButton loading={isSubmitting} type="submit"><FormattedMessage id="send_email" defaultMessage="Send Email" /></BigButton>
                    </div>
            </Form>
            )}
        </Formik>
    </div>
}

const ShareNormalEmailFrom = props =>{

    return <form >

    </form>
}


const ShareEmailModal = props =>{
    const { onClose } = props;

    return <div className={cls.ShareEmail}>
        <div className={cls.Hd}>
            <span className={cls.Font}><FormattedMessage id="share_via_email" defaultMessage="Share via Email" /></span>
            <Iconfont className={cls.Icon} onClick={onClose}>&#xe693;</Iconfont>
        </div>

        <div className={cls.Bd}>
            <ShareEmailForm {...props} />
        </div>
        
    </div>
}

const WrappedEditor = props => {
    useStyles(cls);
    const { show } = props;

	return <React.Fragment>
		<RightToLeft in={show} className={cls.ShareEmailModal}>
			<div>
                <ShareEmailModal {...props} />
			</div>
		</RightToLeft>
	</React.Fragment>
}

export default props =>{
    if (typeof window === 'undefined')
		return null

	return ReactDOM.createPortal(
		<WrappedEditor {...props} />,
		document.getElementById('root')
	)
}